import React from 'react';
import styles from './FuncModal.module.css';
import closeIcon from './../graphics/icons/x.svg';
import xIcon from './../graphics/icons/x-full.svg';
import vIcon from './../graphics/icons/v-full.svg';

function FuncModal({
  topic,
  info,
  goalinfo = '',
  textCancel = '',
  textOK = '',
  funcClose,
  funcCancel,
  funcAgree,
}) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.popWrapper}>
        <div className={styles.xClose} onClick={funcClose}>
          <img src={closeIcon} alt="close" />
        </div>

        <div className={styles.body}>
          <div className={styles.topic}>{topic}</div>
          <div className={styles.info}>{info}</div>
          {goalinfo !== '' && <div className={styles.goalInfo}>{goalinfo}</div>}
        </div>

        <div className={styles.footer}>
          <div
            className={`${styles.btnClose} ${
              textCancel === '' && styles.btnsWrapper
            }`}
            onClick={funcCancel}
          >
            {textCancel !== '' ? (
              textCancel
            ) : (
              <img src={xIcon} style={{ height: '100%' }} alt="cancel" />
            )}
          </div>

          <div
            className={`${styles.btnOK} ${textOK === '' && styles.btnsWrapper}`}
            onClick={funcAgree}
          >
            {textOK !== '' ? (
              textOK
            ) : (
              <img src={vIcon} style={{ height: '100%' }} alt="agree" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FuncModal;
